import { InputGroup, SwitchableFormSection } from '@/components'
import type { FormSectionProps } from '@/containers/forms/FormSection'
import { FormControl, FormLabel, Stack } from '@chakra-ui/react'
import type { EditUser } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef } from 'react'

export const UserMotivationFormSection = forwardRef(function UserMotivationFormSection(props: FormSectionProps, ref: Ref<HTMLDivElement>) {
  const { register, formState: { errors } } = useFormContext<EditUser>()

  const required = (value: string | undefined, formValues: EditUser) => !formValues.properties.userMotivation?.motivationYesNo || !!value

  return <SwitchableFormSection ref={ref} {...props} register={register('properties.userMotivation.motivationYesNo')} sectionTitle='Motivace'>
    <Stack gap={6}>
      <FormControl isInvalid={!!errors.properties?.userMotivation?.salutation}>
        <FormLabel>Oslovení</FormLabel>
        <InputGroup {...register('properties.userMotivation.salutation', {
          maxLength: 100, validate: {
            required: (value, formValues) => required(value, formValues) || 'Zadejte oslovení'
          }
        })} />
      </FormControl>

      <FormControl isInvalid={!!errors.properties?.userMotivation?.nameAndSurname}>
        <FormLabel>Jméno a příjmení</FormLabel>
        <InputGroup {...register('properties.userMotivation.nameAndSurname', {
          maxLength: 100, validate: {
            required: (value, formValues) => required(value, formValues) || 'Zadejte jméno a příjmení'
          }
        })} />
      </FormControl>

      <FormControl isInvalid={!!errors.properties?.userMotivation?.streetAndNumber}>
        <FormLabel>Ulice a č.p.</FormLabel>
        <InputGroup {...register('properties.userMotivation.streetAndNumber', {
          maxLength: 100, validate: {
            required: (value, formValues) => required(value, formValues) || 'Zadejte ulici a č.p.'
          }
        })} />
      </FormControl>

      <FormControl isInvalid={!!errors.properties?.userMotivation?.city}>
        <FormLabel>Město</FormLabel>
        <InputGroup {...register('properties.userMotivation.city', {
          maxLength: 100, validate: {
            required: (value, formValues) => required(value, formValues) || 'Zadejte město'
          }
        })} />
      </FormControl>

      <FormControl isInvalid={!!errors.properties?.userMotivation?.postCode}>
        <FormLabel>PSČ</FormLabel>
        <InputGroup {...register('properties.userMotivation.postCode', {
          maxLength: 20, validate: {
            required: (value, formValues) => required(value, formValues) || 'Zadejte PSČ'
          }
        })} />
      </FormControl>

      <FormControl isInvalid={!!errors.properties?.userMotivation?.email}>
        <FormLabel>E-mail</FormLabel>
        <InputGroup {...register('properties.userMotivation.email', {
          maxLength: 256, validate: {
            required: (value, formValues) => required(value, formValues) || 'Zadejte e-mail'
          }
        })} />
      </FormControl>
    </Stack>
  </SwitchableFormSection>
})
